import { render } from "./farmerSpace.vue?vue&type=template&id=50d64b40&scoped=true&ts=true"
import script from "./farmerSpace.vue?vue&type=script&lang=ts"
export * from "./farmerSpace.vue?vue&type=script&lang=ts"

import "./farmerSpace.vue?vue&type=style&index=0&id=50d64b40&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d64b40"]])

export default __exports__